import { FC } from 'react';

import classNames from 'classnames';
import { useContextSelector } from 'use-context-selector';

import { Avatar, AvatarProps } from '../../Avatar';
import { AVATAR_COLOR_MAPPING, DEFAULT_AVATAR } from '../Message.const';
import { MessageContext } from '../Message.context';

import styles from '../Message.module.scss';

type MessageAvatarProps = Omit<AvatarProps, 'color'>;

export const MessageAvatar: FC<MessageAvatarProps> = ({
  children = DEFAULT_AVATAR,
  ...props
}) => {
  const origin = useContextSelector(MessageContext, ({ origin }) => origin);

  return (
    <Avatar
      size={40}
      {...props}
      color={AVATAR_COLOR_MAPPING[origin]}
      className={classNames(styles.avatar, styles[origin])}
    >
      {children}
    </Avatar>
  );
};
